var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag"},[_vm._m(0),_c('span',[_vm._v(_vm._s(_vm._f("truncate")(_vm.name,50, '..')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"far fa-lock"})])
}]

export { render, staticRenderFns }